__webpack_require__.p = "https://v2-mail.apps.qorcommerce.io/";